/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProjectPriorityDropdown_company$ref: FragmentReference;
declare export opaque type ProjectPriorityDropdown_company$fragmentType: ProjectPriorityDropdown_company$ref;
export type ProjectPriorityDropdown_company = {|
  +id: string,
  +priorityLevels: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +weight: ?number,
        +disabled: ?boolean,
      |}
    |}>
  |},
  +$refType: ProjectPriorityDropdown_company$ref,
|};
export type ProjectPriorityDropdown_company$data = ProjectPriorityDropdown_company;
export type ProjectPriorityDropdown_company$key = {
  +$data?: ProjectPriorityDropdown_company$data,
  +$fragmentRefs: ProjectPriorityDropdown_company$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPriorityDropdown_company",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PriorityLevelTypeConnection",
      "kind": "LinkedField",
      "name": "priorityLevels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PriorityLevelTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PriorityLevel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weight",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "disabled",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company"
};
})();
// prettier-ignore
(node/*: any*/).hash = '43054cbacb172dc1c35fff1e7eecef0f';

module.exports = node;
